import {IntermediatePart} from "../../intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {bottomCabinetModuleSystem} from "./cabinetModuleSystem";

export default class BottomCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'bottom_cabinet';
    this.partName = 'Bottom Cabinet';
    this.layerPriority = 4;
    this.translateId = "visualizer.kitchen.cabinet.bottom_cabinet";
    if (isChild) {
      this.moduleSystem = bottomCabinetModuleSystem;
      this.defaultInlayType = "Wood";
      this.inlayTypes = []; // array of objects, for ex. {name: "Cascade", moduleParts: ["3_2", "7_56"]}
    }
  }

  load(dbFeature) {
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    const module = dbFeature.metaData && dbFeature.metaData["Module"];
    if (module && module[0] !== "0") {
      return super.load_(dbFeature, new BottomCabinet(false, null),true, 'moduleParts');
    } else if (parts) {
      dbFeature.displayName = dbFeature.displayName.replace(/M_0(.*?) /, "M ").replace(/ Part1/, "");
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(dbFeature, new BottomCabinet(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    }
    return super.load_(dbFeature, new BottomCabinet());
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    featuresToDisplay = featuresToDisplay.filter((feature) => {
      if (feature.metaData["Module"]) {
        return (feature.metaData["Module"][0] === "0" && feature.metaData["Part"][0] === "1")
          && feature.metaData["Appliance"] && feature.metaData["Appliance"].includes("Range")
      }
      return true
    });

    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked, clickFrom);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.bottomCabinet.activeFeature = this;
    }
    this.featureClicked();
  }

  availableFeatures(cabinetFeatures) {
    return cabinetFeatures.filter(cabinetFeature => cabinetFeature.partNumber === 1)
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getActiveFeatureConditions(fromFeature = this.activeFeature) {
    const arrayOfConditions = this.getArrayOfConditions();
    const applianceType = fromFeature.metaData["Appliance"] ? fromFeature.metaData["Appliance"][0] : null;
    const cabinetLayout = fromFeature.metaData["CabinetLayout"] ? fromFeature.metaData["CabinetLayout"][0] : null;
    const doorSet = fromFeature.metaData["DoorSet"] ? fromFeature.metaData["DoorSet"][0] : null;
    if (applianceType) {
      arrayOfConditions.push({
        propName: 'Appliance',
        propValue: applianceType
      })
    }
    if (cabinetLayout) {
      arrayOfConditions.push({
        propName: 'CabinetLayout',
        propValue: cabinetLayout
      })
    }
    if (doorSet) {
      arrayOfConditions.push({
        propName: 'DoorSet',
        propValue: doorSet
      })
    }
    return arrayOfConditions
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Cabinet.BottomCabinet;
      const zIndex2 = zIndexes.Cabinet.BottomCabinet2;
      const zIndex3 = zIndexes.Cabinet.Peninsula;
      const zIndexBox = zIndexes.Cabinet.BottomCabinetModuleBox;
      // const zIndexBox2 = zIndexes.Cabinet.BottomCabinetModuleBox2;
      if (this.activeFeature) {
        if (this.activeFeature.metaData["Module"] && this.activeFeature.metaData["Module"][0] === "0") {
          this.activeFeature.layer.zIndex = zIndexBox;
        } else {
          this.activeFeature.layer.zIndex = zIndex;
        }
      }
      if (this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart, activeFeaturePartIndex) => {
          if (activeFeaturePart && activeFeaturePart.layer) {
            if (activeFeaturePart.metaData["Module"] && !activeFeaturePart.metaData["Part"]) {
              const module = activeFeaturePart.metaData["Module"][0];
              const modulePart = activeFeaturePart.metaData["ModulePart"][0];
              activeFeaturePart.layer.zIndex = zIndexes.Cabinet.BottomCabinetModules[module+"_"+modulePart];
            } else {
              activeFeaturePart.layer.zIndex = activeFeaturePartIndex === 0 ? zIndex2 : zIndex3;
              // if (activeFeaturePart.partName.includes("Part2")) {
              //   if (this.activeFeature.metaData["Module"] && this.activeFeature.metaData["Module"][0] === "0") {
              //     activeFeaturePart.layer.zIndex = zIndexBox2;
              //   } else {
              //     activeFeaturePart.layer.zIndex = zIndex2;
              //   }
              // } else if (activeFeaturePart.partName.includes("Part3")) {
              //   activeFeaturePart.layer.zIndex = zIndex3;
              // }
            }
          }
        });
        // go again & try to find the same zIndex, cause we might have 3_3 - 2 times...
        // this.activeFeatureParts
        //   .filter(activeFeaturePart => activeFeaturePart && activeFeaturePart.layer)
        //   .forEach((activeFeaturePart) => {
        //     const hasTheSameZIndex = this.activeFeatureParts.some(testFeaturePart => {
        //       return (testFeaturePart.layer.zIndex === activeFeaturePart.layer.zIndex)
        //         && (testFeaturePart.partName !== activeFeaturePart.partName)
        //     });
        //     if (hasTheSameZIndex) {
        //       activeFeaturePart.layer.zIndex++;
        //     }
        //   })
      }
    }
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
    if (fromFeature && fromFeature.metaData["Module"]) {
      const featureName = fromFeature.getModuleFeatureName();
      const availableFeatures = this.moduleParts.filter((currentFeature) => {
        // 1) filter by module names, e.g. "Hudson Linen White"
        return featureName === currentFeature.getModuleFeatureName();
      });
      for (let i = 1; i <= this.moduleSystem.length; i++ ) {
        const currentModuleSystemNumber = i - 1;
        for (let k = 0; k <= this.moduleSystem[currentModuleSystemNumber].length - 1; k++ ) {
          const modulePart = this.moduleSystem[currentModuleSystemNumber][k];
          const modulePartSplitted = modulePart.split("_");
          const moduleMatchingPart = availableFeatures.find((feature) => {
            return feature.metaData["ModulePartWidth"] && feature.metaData["ModulePartHeight"]
              && +feature.metaData["Module"][0] === i
              && feature.metaData["ModulePartWidth"][0] === modulePartSplitted[0]
              && feature.metaData["ModulePartHeight"][0] === modulePartSplitted[1]
              && feature.metaData["ModulePart"][0] === modulePartSplitted[2]
          });
          if (moduleMatchingPart) {
            activeFeatureParts.push(moduleMatchingPart);
            // } else { // this is for debugging only - look for features which are not exist
            //   console.log("this.moduleSystem[i]", i);
            //   console.log("modulePartIndex", k);
          }
        }
      }
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

  canUseNavigationFilter() {
    return this.activeFeature && this.activeFeature.metaData["Module"]
      && this.activeFeature.metaData["Module"][0] === "0";
  }

}
